import Loading from "../../components/Common/Loading";
import UserSocialInfo from "./userSocialInfo";
import {useEffect, useState} from "react";
import {useGetUserInfoV1TOHQuery} from "../../core/api/toh-analytical-data-api";


const UserSocialInfoTOH = (props) => {

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUserInfoV1TOHQuery(props.deviceId)
    const [infoData, setInfoData] = useState("");

    useEffect(() => {
        setInfoData(data)

    }, [data])

    return (
        <Loading
            isLoading={isLoading}
            isError={isError}
            error={error}
            isSuccess={isSuccess}
        >
            {infoData && <UserSocialInfo
                data={infoData}

            />
            }
        </Loading>
    )
}

export default UserSocialInfoTOH